import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import AllResignationAddPopup from "../../../../components/modelpopup/AllResignationAddPopup";
import ResignationFilterDrawer from "components/Drawer/resignationsFilterDrawer";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import DeleteModal from "../../../../components/modelpopup/DeleteModal";
import ResignationListFilter from "../components/ResignationListFilter";
import { Table, Pagination,  } from "antd";
import {
  itemRender,
  pageSizeOptions,
} from "utils/table";
import {formatDateHandler2} from "utils/common"

import { SkeltonLoader } from "components/skeltonLoader";

import { useResignation } from "../context/resignationContext";
import Image from "components/Image"
import {  toast, Bounce } from 'react-toastify';
import { Button } from "components/Button";
import { getResignationDetailApi } from "api/services/resignations";

//import { deleteResignationApi } from "api/services/resignations";


const AllResignations = () => {
  const {
    loading,
    setLoading,
    searchText,
    resignationData,
    view,
    setView, 
    pageSettings,
    handleGridChange,
    handleChange,
    handleSearchChange,
    handleFilterDrawer,
    showFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    
  
    handleDateChange,

    resignationModal, setResignationModal,
    setSelectedResignation, selectedResignation,
    getResignationList   
  } = useResignation();

  const [deleteModal, setDeleteModal] = useState(false)


  const  handleEditResignation = (item) => {    
    setResignationModal(true)
  }

  const handleResignationDetailPage = (id, index) => {
    console.log(id, index, "=====selected")
   
    if(resignationData) {
       getResignationDetailApi(id).then((response) => {
        console.log(response, "---get api response");
        if(response && response.data) {
          const selectedResignation = response.data;
          setSelectedResignation(selectedResignation || {});
          setResignationModal(true);
        }
      
    });
    }  
  }   
  
  const columns = [
    {
      title: "Emp No.",
      dataIndex: "emp_no",
      sorter: (a, b) => b.id - a.id, 
      defaultSortOrder: "ascend",
      render: (text, record) => (
        <span className="table-avatar">
          {record.company_user?.emp_no}
        </span>
      )      
    },
    {
      title: "First Name",
      dataIndex: "first_name",
    //  sorter: true,
      render: (text, record, index) => (
        <div className="table-avatar d-flex align-items-center">
       
          <a
            onClick={() => handleResignationDetailPage(record.id, index)}
            className="profile-split d-flex flex-column justify-content-center ms-2"
          >
            {record?.company_user?.first_name}
          </a>
        </div>
      ),
    },

    {
      title: "Last Name",
      dataIndex: "last_name",
  //    sorter: true,
      render: (text, record, index) => (
        <div className="table-avatar d-flex align-items-center">
       
          <a
            onClick={() => handleResignationDetailPage(record.id, index)}
            className="profile-split d-flex flex-column justify-content-center ms-2"
          >
            {record?.company_user?.last_name}
          </a>
        </div>
      ),
    },

  
    {
      title: "Designation",
      dataIndex: "position_name",
   //   sorter: true,
      render: (text, record) => (
        <>
        {record?.company_user?.position_name}
        </>
      )
    },   

    {
      title: "Approval Status",
      dataIndex: "approval_status",
     // sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
           <div className="dropdown action-label text-center">
           <span className={`badge badge-soft-${ record?.approval_status == "pending" ?  "warning" : record?.approval_status == "rejected" ? "danger" : "success"}`}>{record?.approval_status}</span>  
           </div>
         
        </span>
      )   
    
    },

    {
      title: "Current Approver",
      dataIndex: "current_approver",
     // sorter: true,
      render: (text, record) => (
        <span className="table-avatar">

            <span className="table-avatar">
              {record?.current_approver ? record?.current_approver?.first_name+ " "+record?.current_approver?.last_name : "-" }
            </span>
         
        </span>
      )   
    
    },


    {
      title: "Last Working Day",
      dataIndex: "last_working_day",
     // sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          {formatDateHandler2(record?.last_working_day) }
        </span>
      )   
    
    },

  


    {
      title: "Reason",
      dataIndex: "reason",
  //   sorter: true,
      render: (text, record) => (
        <span
          className="table-avatar"
        >
          <span
            className="d-inline-block text-truncate align-middle"
            style={{ maxWidth: 150, verticalAlign: "middle" }}
            title={record.reason}
          >
            {record.reason}
          </span>
        </span>
      )
    },

   
    
  ];

  
 
  const GridView = () => {
    if (loading) {
      return (
        <SkeltonLoader
          number={pageSettings?.pageSize}
          active={true}
          className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3 p-2"
        />
      );
    } else {
      return (
        <>
          {resignationData.map((data, index) => (
            <div
              className="col-md-6 col-sm-1 col-12 col-lg-3 col-xl-4"
              key={data.company_user?.id}
            >
              <div className="profile-widget">
               
              
                <div className="row" >
                  <div className="col-4" >
                  <div className="profile-img">
                    <a onClick={()=>handleResignationDetailPage(data.id, index)} className="avatar">
                   
                      <Image  src={data?.company_user?.profile_image} type="user" alt="User Image" style={{ objectFit: "cover" }} />
                    </a>
                  </div>
                  
                  </div>
                 
                  <div  className="col-8" >
                  <h4 className="user-name m-t-10 mb-0 text-ellipsis text-start">
                  <a                 
                  onClick={()=>handleResignationDetailPage(data.id, index)}
                  >
                    {data.company_user?.first_name} {data?.company_user?.last_name}
                  </a>
                </h4>
                <div className="small text-muted text-start">{data.company_user?.email}</div>

                <div className="small text-muted text-start">{data.company_user?.position_name}</div>

                  </div>
                  
                    </div>
                

              </div>
            </div>
          ))}
        </>
      );
    }
  };
  
  
  const reloadPage = () => {
    getResignationList()
  } 



  const deleteHandler = (props) => {
    console.log(selectedResignation, "LLLLLLLL")
    // deleteResignationApi(selectedResignation?.id).then(res=>{
    //   toast.success('Resignation deleted successfully!', {
    //     position: "top-right",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     closeOnClick: false,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    //     theme: "light",
    //     transition: Bounce,
    //     });
    //     getResignationList()
    //     setDeleteModal(false)
    // }).catch(e=>{
    //   toast.error('Error deleting resignation!', {
    //     position: "top-right",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     closeOnClick: false,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    //     theme: "light",
    //     transition: Bounce,
    //     });
    // })
  }

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
     
        
          <Breadcrumbs
           maintitle="Resignation"
           title="Dashboard"
           subtitle="Resignation"
           modal="#add_resignation"
           name="Apply Resignation"
           view={view}
           setResignationModal={setResignationModal}
           setView={setView}            
          />

          <ResignationListFilter
           filters={filters} 
           handleInputChange={handleInputChange} 
           searchPlaceholder={"Search Resignation"} 
           handleFilterDrawer={handleFilterDrawer}
            handleFilterChange={handleFilterChange}
            loading={loading}
          />



                   {view == "grid" ? (
                     <div className="row">    
                       <GridView />
                       <div className="my-2 d-flex justify-content-end ">
                         <div className="col-sm-12 col-md-6 ">
                         <Pagination
                             pageSize={pageSettings?.pageSize}
                             pageSizeOptions={pageSizeOptions}
                             defaultCurrent={1}
                             current={pageSettings?.page}
                             total={pageSettings?.total}
                             // itemRender={itemRender}
                             onChange={handleGridChange}
                             showLessItems
                             showSizeChanger={false}
                             showQuickJumper={false}
                             hideOnSinglePage
                             itemRender={(page, type, originalElement) => {
                               if (type === "next") {
                                 return (
                                   <Button
                                     loading={loading}
                                     // disabled={loading || (selectedLeavePlanner && selectedLeavePlanner?.leave_planner?.company_user?.id != user?.id)}
                                     className="btn btn-primary "
                                     // type="Load More"
                                     label="Load More"
                                   />
                                 );
                               }
                               return null;
                             }}
                           />
                         </div>
                       </div>
                     </div>
                   ) : (
            <div className="row">
              <div className="table-responsive">
                {/* <SearchBox pageSettings={pageSettings} setPageSettings={setPageSettings} /> */}
                <Table
                // scroll={{ x: "max-content", y: "max-content" }} // 👈 Keeps horizontal scrollbar
                  className="table-striped"
                  columns={columns}
                  dataSource={resignationData}
                  rowKey={(record) => record.id}
                  loading={loading}
                  pagination={{
                    total: pageSettings?.total,
                    pageSize: pageSettings?.pageSize,
                    showSizeChanger: true,
                    pageSizeOptions: pageSizeOptions,
                    // showQuickJumper: true,
                    itemRender: itemRender,
                    position: "right",
                    current: pageSettings?.page,
                    showTotal: (total, range) =>
                      `${range[0]}-${range[1]} of ${total} items`,
                  }}
                  onChange={handleChange}
                />
              </div>
            </div>
                   )}
         

      <AllResignationAddPopup getResignationList={getResignationList} setSelectedResignation={setSelectedResignation} setLoading={setLoading} selectedResignation={selectedResignation} loading={loading} reloadPage={reloadPage}  resignationModal={resignationModal} setResignationModal={setResignationModal} />
      {/* Delete Modal */}
      <DeleteModal deleteModal={deleteModal} setDeleteModal={setDeleteModal} deleteHandler={deleteHandler} Name="Delete Record" />
        </div>
      </div>

  
    

      <ResignationFilterDrawer
          searchPlaceholder={"Search Resignations"}
          showFilterDrawer={showFilterDrawer}
          handleFilterDrawer={handleFilterDrawer}
          handleFilterChange={handleFilterChange}
          filters={filters}
          handleInputChange={handleInputChange}
          handleApplyFilter={handleApplyFilter}
          filterLoading={filterLoading}
          handleDateChange={handleDateChange}
/>
      {/* Delete Modal */}
    </>
  );
};

export default AllResignations;
